<app-page-ribbon></app-page-ribbon>
<div>
    <app-navbar></app-navbar>
</div>
<div class="container-fluid">
    <div class="card jh-card">
        <router-outlet></router-outlet>
        <router-outlet name="popup"></router-outlet>
    </div>

    <app-footer></app-footer>
</div>
